import { render, staticRenderFns } from "./SecondaryTitle.vue?vue&type=template&id=49731926&scoped=true&"
import script from "./SecondaryTitle.vue?vue&type=script&lang=js&"
export * from "./SecondaryTitle.vue?vue&type=script&lang=js&"
import style0 from "./SecondaryTitle.vue?vue&type=style&index=0&id=49731926&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49731926",
  null
  
)

export default component.exports